export const IossNumber = 'IossNumber';
export const ExportReason = 'ExportReason';
export const BuyerNote = 'Buyer Note';
export const LabelReference = 'LabelReference';
export const GSP = 'GSP';
export const Prime = 'Prime';
export const DeliveryInstructions = 'Delivery Instructions';
export const DeliverySafePlace = 'Delivery Safe Place';
export const EoriNumber = 'EoriNumber';
export const VatNumber = 'VatNumber';
export const TaxId = 'TaxId';
export const VatStatus = 'VatStatus';
export const CurrencyConversion = 'CurrencyConversion';
export const MarketplaceService = 'MarketplaceService';
export const PickupShopId = 'PickupShopId';
